import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/pages/Login/Login.vue';
import ForgotPassword from '@/components/pages/ForgotPassword/ForgotPassword.vue';
import ResetPassword from '@/components/pages/ResetPassword/ResetPassword.vue';
import Logout from '@/components/pages/Logout/Logout.vue';
import AccountNotSetup from '@/components/pages/AccountNotSetup.vue';
import TokenAuth from '@/components/pages/TokenAuth/TokenAuth.vue';
import SAMLAuth from '@/components/pages/SAMLAuth/SAMLAuth.vue';
import AcceptInvite from '@/components/pages/AcceptInvite/AcceptInvite.vue';
import SelectAccount from '@/components/pages/SelectAccount/SelectAccount.vue';
import Welcome from '@/components/pages/Welcome/Welcome.vue';
import Success from '@/components/pages/Success/Success.vue';
import EmailValidation from '../components/sections/EmailValidation/EmailValidation.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/launchpad/',
  routes: [
    {
      path: '/login/:productCode?',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Log in',
      },
    },
    {
      path: '/forgotpassword/:productCode?',
      name: 'Recover Password',
      component: ForgotPassword,
      meta: {
        title: 'Recover password',
      },
    },
    {
      path: '/resetpassword/:userId/:token',
      name: 'Reset Password',
      component: ResetPassword,
      meta: {
        title: 'Reset password',
      },
    },
    {
      path: '/logout/:productCode?',
      name: 'Logout',
      component: Logout,
      meta: {
        title: 'Log out',
      },
    },
    {
      path: '/notsetup/:productCode',
      name: 'Account Not Setup',
      component: AccountNotSetup,
      meta: {
        title: 'Account not setup',
      },
    },
    {
      path: '/saml/auth',
      name: 'Single Sign On',
      component: SAMLAuth,
      meta: {
        title: 'Log in',
      },
    },
    {
      path: '/tokenauth',
      name: 'Token Login',
      component: TokenAuth,
      meta: {
        title: 'Log in',
      },
    },
    {
      path: '/acceptinvite/:productCode?',
      name: 'Accept Invite',
      component: AcceptInvite,
      meta: {
        title: 'Get Started',
      },
    },
    {
      path: '/join/:productCode?',
      name: 'Join Teamwork',
      component: AcceptInvite,
      meta: {
        title: 'Get started',
      },
    },
    {
      path: '/googleSSO/select-account',
      name: 'Google Sign-In',
      component: SelectAccount,
      meta: {
        title: 'Log in',
      },
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
      meta: {
        title: 'Welcome',
        hideSiteLogo: true,
      },
    },
    {
      path: '/success',
      name: 'Success',
      component: Success,
      meta: {
        title: 'Log in',
      },
    },
    {
      path: '/verifyemail/:productCode/:token',
      name: 'Success',
      component: EmailValidation,
      meta: {
        title: 'Verify email',
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js